import React from 'react';
import { Box, HStack } from 'native-base';
import Cash from './Cash';
import Point from './Point';
import { GIFTCARD_FLOWS } from '@springbig/shared';
import { useTheme } from '@springbig/shared';

const GiftCardBalance = ({
    setIsSetNameModalOpen,
    setOnSubmitAction
}: {
    setIsSetNameModalOpen: (value: boolean) => void
    setOnSubmitAction: (value: GIFTCARD_FLOWS | undefined) => void
}) => {

    const { primary } = useTheme();

    return (
        <HStack justifyContent={'space-around'} py={4}>
            <Cash />
            <Box
                borderLeftColor={primary}
                borderLeftWidth={0.60}
                h='70%'
                alignSelf={'center'}
            />
            <Point setOnSubmitAction={setOnSubmitAction} setIsSetNameModalOpen={setIsSetNameModalOpen} />
        </HStack>
    );
};

export default GiftCardBalance;
